import { register, CloudObject, Tag, Transaction, defineProperty, defineRelation, Direction } from 'olympe';
import TranslatedString from "./TranslatedString";
import Picture from "./Picture";

/**
 * @extends {CloudObject}
 */
export default class Evaluation extends CloudObject {

    /**
     * Creates an instance of Evaluation.
     *
     * @param {!Transaction} transaction
     * @return {!string} the tag of the created instance
     */
    static create(transaction) {
        return transaction.create(Evaluation);
    }
    
    /**
     * @return {number}
     */
    getValue() {
        return this.get(Evaluation.valueProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<number>}
     */
    observeValue($) {
        return this.observe($, Evaluation.valueProp);
    }

    /**
     * @return {boolean}
     */
    getIsCustom() {
        return this.get(Evaluation.isCustomProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<boolean>}
     */
    observeIsCustom($) {
        return this.observe($, Evaluation.isCustomProp);
    }

    /**
     * @return {string}
     */
    getName() {
        return this.get(Evaluation.nameProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeName($) {
        return this.observe($, Evaluation.nameProp);
    }

    /**
     * @return {string}
     */
    getDescription() {
        return this.get(Evaluation.descriptionProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeDescription($) {
        return this.observe($, Evaluation.descriptionProp);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {number} value
     */
    static setValue(transaction, instance, value) {
        transaction.update(instance, Evaluation.valueProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {boolean} value
     */
    static setIsCustom(transaction, instance, value) {
        transaction.update(instance, Evaluation.isCustomProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setName(transaction, instance, value) {
        transaction.update(instance, Evaluation.nameProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setDescription(transaction, instance, value) {
        transaction.update(instance, Evaluation.descriptionProp, value);
    }

}

// Hardcoded tags
register('01880fc638f1f8bd778b', Evaluation);
Evaluation.valueProp = defineProperty('01880fc678c7b1018c50');
Evaluation.isCustomProp = defineProperty('01880fc69058b913e022');
Evaluation.nameProp = defineProperty('018a97b6465181d4d056');
Evaluation.descriptionProp = defineProperty('018a97b654516ee56e24');
Evaluation.picturesRel = defineRelation('01880fc6c31962221a15', Evaluation, Picture);
Evaluation.translatedNameRel = defineRelation('018a97b6d9ef87e0cb2f', Evaluation, TranslatedString);
Evaluation.translatedDescriptionRel = defineRelation('018a97b6f6aea975788b', Evaluation, TranslatedString);
Evaluation.inverse_inspectionevaluationsListRel = defineRelation('01880fd534cbc9e5e5ff', Direction.ORIGIN);
Evaluation.inverse_observationevalutationRel = defineRelation('01896d29133e0bcc3498', Direction.ORIGIN);
Evaluation.inverse_observationadditionalEvalsRel = defineRelation('0189785c6aceee8d89fe', Direction.ORIGIN);
